import { ZodSchemaInfo, ZodTypeWithMeta } from '../types/zodType'
import { formatDate, parseDate } from '../types/date'
import { formatDateTime, parseDateTime } from '../types/dateTime'
import { isEmpty } from './empty'
import { formatAsBrNumber } from './types/number'

export default function formatBasedOnType(
  value: any,
  type: ZodSchemaInfo,
  fill: string | null = null,
): string | null {
  if (isEmpty(value)) {
    return fill
  }

  if (type.type === 'number') {
    return formatAsBrNumber(value)
  }
  if (type.type === 'boolean') {
    return value ? 'Sim' : 'Não'
  }
  if (type.type === 'Date' && value.length === 10) {
    return formatDate(parseDate(value))
  }
  if (type.type === 'Date' && value.length > 10) {
    return formatDateTime(parseDateTime(value))
  }
  if (type.type === 'enumerated') {
    const keysAndLabels = type?.meta?.keysAndLabels as Record<string, string> | undefined
    return keysAndLabels ? keysAndLabels[value] || fill : fill
  }
  if (type.type === 'Array' && Array.isArray(value)) {
    return (type?.shape as any)
      ?.map((item: ZodSchemaInfo, index: number) => formatBasedOnType(value[index], item, fill))
      .join(', ')
  }
  if (type.type === 'string') {
    return String(value)
  }

  console.warn(`Unknown type ${type.type} for value ${value}`)
  return String(value)
}
